/*
 * <shop-by-age-divider>
 * Paints the divider's two wave layers to match its neighbors' surfaces.
 *
 * Each Shopify section is wrapped in a `.shopify-section` element, so the
 * divider's true siblings are one level up. We read the `data-bg` enum the
 * Shop By Age sections already emit on their inner wrapper and mirror it onto
 * this element's data-color-top (section above) / data-color-bottom (section
 * below). The CSS does the rest via attribute selectors.
 *
 * Falls back to the markup defaults when a neighbor is missing or has no
 * data-bg (e.g. a Dawn section), so the seam degrades to a flat, safe color
 * rather than a wrong-colored wave.
 *
 * A side carrying data-lock-top / data-lock-bottom was pinned by a merchant
 * (the section's "Wave colors" override) and is left untouched, so the divider
 * still colors correctly between sections that don't advertise a data-bg.
 *
 * Every divider section tags this file, so a page with N dividers runs it N
 * times. The guard + class expression keep the second run from redeclaring a
 * global class ("Identifier 'ShopByAgeDivider' has already been declared", once
 * per extra divider, measured on production 2026-09-25) or redefining the tag.
 */
if (!customElements.get('shop-by-age-divider')) {
  customElements.define('shop-by-age-divider', class ShopByAgeDivider extends HTMLElement {
    connectedCallback() {
      this.#resolveColors();

      // Theme editor: neighbors can change or reorder without a full reload.
      if (window.Shopify && window.Shopify.designMode) {
        this.#boundResolve = this.#resolveColors.bind(this);
        document.addEventListener('shopify:section:load', this.#boundResolve);
        document.addEventListener('shopify:section:reorder', this.#boundResolve);
      }
    }

    disconnectedCallback() {
      if (this.#boundResolve) {
        document.removeEventListener('shopify:section:load', this.#boundResolve);
        document.removeEventListener('shopify:section:reorder', this.#boundResolve);
      }
    }

    #boundResolve = null;

    #resolveColors() {
      const wrapper = this.closest('.shopify-section');
      if (!wrapper) return;

      const above = wrapper.previousElementSibling?.querySelector('[data-bg]');
      const below = wrapper.nextElementSibling?.querySelector('[data-bg]');

      if (this.dataset.lockTop !== 'true' && above && above.dataset.bg) this.dataset.colorTop = above.dataset.bg;
      if (this.dataset.lockBottom !== 'true' && below && below.dataset.bg) this.dataset.colorBottom = below.dataset.bg;
    }
  });
}
